<template>
  <div class="emat-category">
    <InfoPopup v-if="infoPopup" v-bind="infoPopup" />
    <div class="icon">
      <img :src="image">
    </div>
    <div class="flex">
      <span class="label" v-text="label"></span>
      <span class="amount"></span>
      <span class="add" @click="showPopup">{{ viewButtonText }}</span>
    </div>
  </div>
</template>

<script>
import InfoPopup from '../../General/Info';
import cables from "../../../assets/icons/cables.svg?inline";
import components from "../../../assets/icons/car.svg?inline";
import tubes from "../../../assets/icons/cogwheel.svg?inline";
import fixation from "../../../assets/icons/info.svg?inline";

import {mapGetters} from 'vuex';

export default {
  name: 'ProductCategory',
  props: {
    /**
     * A boolean specifying whether to use a cart icon: {use as: [:icon="true"]}
     */
    showIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * A label for the product
     */
    label: {
      type: String,
      required: false,
      default: '',
    },
    /**
     * Name of the image to show [cables, components, tubes, fixation]
     */
    image: {
      type: String,
      required: false,
      default: '',
    },
    viewButtonText: {
      type: String,
      default: 'Bekijk'
    },
    menu: {
      type: Boolean,
      required: false,
      default: false,
    },
    infoPopup: {
      type: Object,
      required: false,
      default: null,
    },
  },
  components: {
    cables,
    components,
    tubes,
    fixation,
    InfoPopup,
  },

  methods: {
    showPopup() {
      /**
       * Emit which item to popup
       */
      this.$emit('showPopup', this.label);
    },
  },
  computed: {
    ...mapGetters({
      products: 'products/getAll',
    }),
    productAmount() {
      if (this.products) {
        return this.products[0].amount; //@todo for each individual category
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/abstracts";

.emat-category {
  padding: 0 12px;
  font-family: var(--font);
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 56px;
  background: var(--c-zebra-stripe);

  &.mobile {
    max-width: 100%;
  }

  .icon {
    height: 48px;
    width: 48px;

    img {
      width: 40px;
      height: 40px;
    }
  }

  .flex {
    padding-left: 10px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .label {
      font-size: var(--card-item-font-size);
    }

    .add {
      font-family: var(--font-black);
      font-weight: 800;
      font-size: 14px;
      color: var(--c-link);
      cursor: pointer;
      transition: all ease 0.2s;

      &:hover {
        color: var(--c-link-hover);
      }
    }
  }

  .emat-product-backdrop {
    background-color: rgba(0, 0, 0, .5);
    position: fixed;
    z-index: 3;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  }

  .emat-product-popup {
    box-sizing: border-box;
    padding: 20px;
    background: #fff;
    margin: auto;
    width: 100%;
    max-width: 590px;
    min-height: 150px;
    z-index: 4;
    box-shadow: -2px 0 15px rgba(0, 0, 0, .1);
    font-family: var(--font);

    &:after {
      content: "";
      display: block;
      height: 10px;
      width: 10px;
      background: inherit;
      position: absolute;
      top: 18px;
      left: 0;
      transform: translateX(-50%) rotate(45deg);
    }
  }

  .emat-product-close {
    width: 20px;
    height: 20px;
    position: relative;
    float: right;
    margin-top: -4px;
    cursor: pointer;

    &:before,
    &:after {
      content: "";
      display: block;
      height: 2px;
      width: 18px;
      background: var(--c-popup-background);
      position: absolute;
      top: 50%;
      left: 50%;
    }

    &:before {
      transform: translateX(-50%) translateY(-50%) rotate(45deg);
    }

    &:after {
      transform: translateX(-50%) translateY(-50%) rotate(-45deg);
    }
  }

  &:nth-child(odd) {
    background-color: $white;
  }
  &:last-child {
    border-bottom-left-radius: $border-radius;
    border-bottom-right-radius: $border-radius;
  }
}
</style>
